<script>
import { getAppConfig } from 'larasnap';

export default {
    props: {
        name: String,
        label: String,
        field: String,
        dataType: { type: String, default: 'default' },
        dateFormat: {
            type: String,
            default: getAppConfig('flextable_date_format'),
        },
        datetimeFormat: {
            type: String,
            default: getAppConfig('flextable_datetime_format'),
        },
        searchable: { type: Boolean, default: true },
        sortable: { type: Boolean, default: true },
        sort: { type: String, default: null },
        sortBy: { type: Function, default: null },
        wrapText: { type: Boolean, default: false },
        width: { type: [String, Number], default: '' },
        display: { type: Function, default: null },
        displayType: { type: String, default: '' },
    },
    render() {
        return null;
    },
};
</script>
